<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @checkboxChange="(e) => (checkedRows = e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
          v-if="allow('A')"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <!-- <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
          v-if="allow('S')"
        > -->
        <!-- <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="submit()"
            :disabled="!checkedRowCount"
          >
            {{ $l('btn_submit') || '提交审核' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button> -->
        <!-- </el-badge> -->
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <AddFirstOrder
      v-if="addPlanOptions.visible"
      :visible.sync="addPlanOptions.visible"
      @close="close"
    ></AddFirstOrder>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import AddFirstOrder from '../add-first-order'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, AddFirstOrder },
  data() {
    return {
      checkedRows: [],
      usePage: true,
      addPlanOptions: {
        visible: false,
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandListApi({ ...form, ...this.page })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
      this.clearCheckboxRow()
    },

    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-skuFirstOrder-detail',
        params: { pageType, ...params },
        query: { ...query },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
